module.exports = __webpack_public_path__ + "img/FG.e0d484a5.png";